import { Coefficients } from "../data/general";

export const isoToString = (date = "2023-06-30T15:43:08.781Z") => {
  return new Date(date).toLocaleDateString();
};
export const stringToISO = (date) => {
  if (date) return new Date(date).toISOString();
  else return new Date().toISOString();
};

export const addTimeToDate = (props) => {
  let {
    date = new Date()?.toISOString(),
    days = 1,
    milliseconds = 0,
  } = props ?? {};
  let date1 = new Date(date);
  let newDate;
  if (milliseconds > 0) {
    newDate = new Date(date1).setTime(date1.getTime() + milliseconds);
  } else newDate = new Date(date1).setDate(date1.getDate() + days);
  return new Date(newDate);
};
export const convertToMilliseconds = ({ unit = "day", value = 0 }) => {
  return value * Coefficients[unit];
};

export const isExpiredDate = ({ date = new Date() }) => {
  const now = new Date();
  const targetDate = new Date(date);
  if (new Date(now) > new Date(targetDate)) return true;
  else return false;
};

export const remainingTime = ({ date }) => {
  const now = new Date().getTime();
  const targetDate = new Date(date).getTime();
  const diff = targetDate - now;
  if (diff < 0) return 0;
  if (diff / Coefficients.minute < 60) {
    return { value: diff / Coefficients.minute, unit: "minute" };
  } else if (diff / Coefficients.hour < 24) {
    return { value: diff / Coefficients.hour, unit: "hour" };
  } else {
    return { value: diff / Coefficients.day, unit: "day" };
  }
};
